import {apiPost} from './api.client';

let profileClient = (function() {
    let getFirstName = () => {
        let payload = {
            query: 'query getFirstName { userProfile { firstName } }',
            variables: null,
            operationName: null
        };

        return apiPost('/profile/graphql', payload)
            .then((response) => response.json())
            .then((json) => {
                return json.data.userProfile.firstName;
            })
            .catch(() => {
                return '';
            });
    };

    return {
        getFirstName
    };
}());

export default profileClient;
